import React from "react";
import { BasicFieldProps } from "./props";
import classNames from "classnames";

export const FileUpload = (props: BasicFieldProps): JSX.Element => {
  const { field, fieldId } = props;
  const { label, placeholder, isRequired, cssClass, id, layoutGridColumnSpan } = field;
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;

  const [file, setFile] = React.useState<File | null>(null);

  const handleSelectedFile = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <div
      className={classNames({
        [cssClass]: cssClass,
        required: isRequired,
      })}
      style={{ "--col-width": layoutGridColumnSpan || 12 } as React.CSSProperties}
    >
      <span className="upload-info">{file ? file?.name : label}</span>
      <label htmlFor={fieldId}>Upload PDF...</label>

      <input
        name={gfName}
        id={fieldId}
        placeholder={placeholder || "Upload CV"}
        required={!!isRequired}
        type="file"
        onChange={handleSelectedFile}
        accept="application/pdf"
      />
    </div>
  );
};
